// Endpoints
import env from "@/services/env";

// @todo this smells, if we need the webapp path, we'd have to pick it up from window object or similar
//  (= use current url from browser location)
export const webappLink = (): string => ''; // process.env.VUE_APP_BASE_URL;

// @todo
const apiUrl = (): string => "";

// @todo @ramon pls check the values
export const subscriptionVapidKey = (): string => {
  let key;
  // we must receive this at _build_ time only
  // we can inject it from mobi/services/droppo_app.yaml ONLY when in DEV MODE
  if (process.env.VUE_APP_VAPID_KEY) {
    key = process.env.VUE_APP_VAPID_KEY;
  } else if (env.isProduction()) {
    key = "BLxQOeTuPwMi3eyoouQuh4FSsG7aNfz4TnjRw_OLcxv10WK4UswG0vSKnkD6krhdMHVdET1j7KzaSLw_8_D_Pq8";
  } else if (env.isStaging()) {
    key = "BI9JjWwcKvTtaC9te0vHW30qE2RhWHl9yJsP-7ref42N26S5HzBPECLmz0V9LJVObfoyBKL-19UPNvQ9b-dceYM\";";
  } else {
    key = "BI9JjWwcKvTtaC9te0vHW30qE2RhWHl9yJsP-7ref42N26S5HzBPECLmz0V9LJVObfoyBKL-19UPNvQ9b-dceYM";
  }

  return key;

};

export const apiEndpoint = (): string => apiUrl() + "/api/v1/";
export const paymentUrl = (): string => apiUrl() + "/pay/";
export const pushSubscriptionUrl = (): string => apiUrl() + "/subscribe/";
